import * as React from 'react';

import { cn } from '@/lib/utils';

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          'flex min-h-[80px] w-full rounded-md',
          'border border-gray-200 dark:border-gray-700',
          'bg-white dark:bg-gray-900',
          'px-3 py-2 text-sm',
          'ring-offset-white dark:ring-offset-gray-900',
          'placeholder:text-gray-500 dark:placeholder:text-gray-400',
          'focus-visible:outline-none',
          'focus-visible:ring-2 focus-visible:ring-purple-500 dark:focus-visible:ring-purple-400',
          'focus-visible:ring-offset-2',
          'disabled:cursor-not-allowed',
          'disabled:bg-gray-50 dark:disabled:bg-gray-900/95',
          'disabled:border-gray-100 dark:disabled:border-purple-900/20',
          'disabled:placeholder:text-gray-400 dark:disabled:placeholder:text-purple-200/20',
          'dark:text-gray-100 dark:disabled:text-gray-100/50',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Textarea.displayName = 'Textarea';

export { Textarea };
